'use strict';

// Adds accessible labels to Query Block more link
let read_mores = document.querySelectorAll('.wp-block-post-excerpt__more-link');
read_mores.forEach( link => {
    let post_title = link.closest('.wp-block-post').querySelector('.wp-block-post-title').innerText;
    link.setAttribute( 'aria-label', 'Read more about ' + post_title );
});


// ──────────────────────────────────────────────────
// SFS Filter Enhancements
// ──────────────────────────────────────────────────
(function () {

    // ── All SFS enhancements require jQuery (for .trigger('change') compat
    //    with the plugin's delegated handlers). Since PerfMatters loads this
    //    script with async, we poll until jQuery is available. ──
    function initSfsEnhancements() {
        var $ = jQuery;

        // ── Debounced search: fires after 800ms idle ──
        var debounceTimer = null;

        // Track whether we're mid-search so we can restore focus
        var pendingSearchState = null;

        $(document).on('input', '.sfswp-search-field', function () {
            var $field = $(this);
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
                // Save search state BEFORE triggering AJAX
                var el = $field[0];
                pendingSearchState = {
                    value: el.value,
                    selStart: el.selectionStart,
                    selEnd: el.selectionEnd
                };
                // jQuery .trigger() is required — vanilla dispatchEvent
                // does NOT fire jQuery delegated event handlers.
                $field.trigger('change');
            }, 800);
        });

        // Prevent full page reload on Enter — trigger change immediately
        $(document).on('keydown', '.sfswp-search-field', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(debounceTimer);
                var el = this;
                pendingSearchState = {
                    value: el.value,
                    selStart: el.selectionStart,
                    selEnd: el.selectionEnd
                };
                $(this).trigger('change');
            }
        });

        // ── Post-AJAX: fix reveals, spinner, and restore search focus ──
        $(document).ajaxComplete(function (event, xhr, settings) {
            // Only act on SFS filter AJAX requests
            if (!settings || !settings.data || typeof settings.data !== 'string') return;
            if (settings.data.indexOf('sfswpAjaxAction=filter') === -1) return;

            var container = document.getElementById('sfs-posts-container');
            if (container) {
                // Mark container so CSS override forces opacity:1 on [data-reveal]
                container.classList.add('sfs-ajax-loaded');

                // Also directly fix any reveal elements the CSS hasn't caught yet
                var reveals = container.querySelectorAll('[data-reveal]');
                reveals.forEach(function (el) {
                    el.style.opacity = '1';
                    el.style.transform = 'none';
                });
            }

            // Spinner failsafe
            var spinner = document.querySelector('.sfswp-spinner');
            if (spinner) {
                spinner.classList.remove('is-active');
            }
            document.documentElement.classList.remove('is-active');
            document.body.style.cursor = 'auto';
            document.documentElement.style.cursor = 'auto';

            // ── Restore search focus after DOM replacement ──
            // The SFS plugin's sfswpReloadFiltersWidget() replaces the
            // entire widget DOM, destroying the focused search input.
            // We re-find the new element and restore state.
            if (pendingSearchState) {
                var state = pendingSearchState;
                pendingSearchState = null;

                // Use requestAnimationFrame to let the DOM settle
                requestAnimationFrame(function () {
                    var newField = document.querySelector('.sfswp-search-field');
                    if (newField) {
                        // Restore value in case the AJAX response cleared it
                        if (newField.value !== state.value) {
                            newField.value = state.value;
                        }
                        newField.focus();
                        // Restore cursor position
                        try {
                            newField.setSelectionRange(state.selStart, state.selEnd);
                        } catch (e) {
                            // setSelectionRange may throw on some input types
                        }
                    }
                });
            }
        });
    }

    // Wait for jQuery (handles async script loading by PerfMatters)
    if (typeof jQuery !== 'undefined') {
        initSfsEnhancements();
    } else {
        var jqPollCount = 0;
        var jqPoll = setInterval(function () {
            jqPollCount++;
            if (typeof jQuery !== 'undefined') {
                clearInterval(jqPoll);
                initSfsEnhancements();
            } else if (jqPollCount > 50) { // ~5 seconds
                clearInterval(jqPoll);
            }
        }, 100);
    }

})();

